/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CardPagedItemsCardResponseCardMetadataDto,
  CardResponse,
  GetOrganisationCardsPagedParams,
  GetUserCardsPagedParams,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class MobileApiCardsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-api-cards-controller
   * @name ActivateVirtualCard1
   * @request PUT:/api/m/cards/activate/virtual/{cardId}
   */
  activateVirtualCard = (cardId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/m/cards/activate/virtual/${cardId}`,
      method: 'PUT',
      ...params,
    })

  static activateVirtualCardPath = '/m/cards/activate/virtual/${cardId}'
  static activateVirtualCardMethod = 'PUT'
  /**
   * No description
   *
   * @tags mobile-api-cards-controller
   * @name GetCards
   * @request GET:/api/m/cards
   */
  getCards = (params: RequestParams = {}) =>
    this.http.request<CardResponse[], any>({
      path: `/m/cards`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCardsPath = '/m/cards'
  static getCardsMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-api-cards-controller
   * @name GetCard2
   * @request GET:/api/m/cards/{cardId}
   */
  getCard = (cardId: string, params: RequestParams = {}) =>
    this.http.request<CardResponse, any>({
      path: `/m/cards/${cardId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCardPath = '/m/cards/${cardId}'
  static getCardMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-api-cards-controller
   * @name GetUserCardsPaged
   * @request GET:/api/m/cards/user/paged
   */
  getUserCardsPaged = (query: GetUserCardsPagedParams, params: RequestParams = {}) =>
    this.http.request<CardPagedItemsCardResponseCardMetadataDto, any>({
      path: `/m/cards/user/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getUserCardsPagedPath = '/m/cards/user/paged'
  static getUserCardsPagedMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-api-cards-controller
   * @name GetOrganisationCardsPaged
   * @request GET:/api/m/cards/organisation/paged
   */
  getOrganisationCardsPaged = (
    query: GetOrganisationCardsPagedParams,
    params: RequestParams = {},
  ) =>
    this.http.request<CardPagedItemsCardResponseCardMetadataDto, any>({
      path: `/m/cards/organisation/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getOrganisationCardsPagedPath = '/m/cards/organisation/paged'
  static getOrganisationCardsPagedMethod = 'GET'
}
